module.exports = __webpack_public_path__ + "static/logo-des-0a9a701987dd02c6f5bf719d590d010e.png";